import React from "react";
import { FiArrowRight, FiChevronRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const TONES = {
  blue: {
    accent: "bg-[#2563eb]",
    icon: "text-[#2563eb]",
    iconSurface: "bg-[#e8efff]",
    action: "border-[#2563eb] text-[#2563eb] hover:bg-[#eff4ff]",
    visual: "bg-[#edf3ff]",
  },
  green: {
    accent: "bg-[#159447]",
    icon: "text-[#159447]",
    iconSurface: "bg-[#e4f7e9]",
    action: "border-[#159447] text-[#159447] hover:bg-[#edfbf1]",
    visual: "bg-[#eaf9ef]",
  },
};

export function HomeOverviewCard({
  tone,
  title,
  description,
  count,
  countLabel,
  to,
  Icon,
  VisualIcon,
  illustration,
}) {
  const colors = TONES[tone];

  return (
    <section className="relative min-h-[285px] overflow-hidden rounded-[26px] border border-slate-100 bg-white shadow-[0_12px_32px_rgba(15,23,42,0.08)] sm:min-h-[270px]">
      <span className={`absolute inset-y-0 left-0 w-1.5 ${colors.accent}`} />
      <Link
        aria-label={`Open ${title}`}
        className="absolute right-5 top-5 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-slate-100 bg-white text-slate-950 shadow-sm transition hover:bg-slate-50"
        to={to}
      >
        <FiChevronRight className="h-6 w-6" />
      </Link>

      <div className="relative z-[1] flex h-full min-h-[285px] flex-col px-6 py-7 pr-20 sm:min-h-[270px] sm:px-9 sm:py-8 sm:pr-[18rem]">
        <div className={`mb-4 sm:mb-5 flex h-14 w-14 sm:h-20 sm:w-20 shrink-0 items-center justify-center rounded-2xl sm:rounded-[24px] ${colors.iconSurface}`}>
          <Icon className={`h-7 w-7 sm:h-11 sm:w-11 ${colors.icon}`} strokeWidth={2} />
        </div>
        <h2 className="m-0 text-xl sm:text-2xl md:text-[29px] font-bold leading-tight tracking-tight text-slate-950 whitespace-nowrap">
          {title}
        </h2>
        <p className="mb-0 mt-2 max-w-sm text-sm sm:text-base md:text-lg font-medium leading-6 text-slate-600">
          {description}
        </p>
        <div className="mt-5 flex items-baseline gap-2.5">
          <span className={`text-4xl font-bold leading-none sm:text-5xl ${colors.icon}`}>
            {count}
          </span>
          <span className="text-base font-medium text-slate-600 sm:text-lg">{countLabel}</span>
        </div>
        <Link
          className={`mt-6 inline-flex w-fit items-center gap-3 sm:gap-5 rounded-xl sm:rounded-2xl border px-5 sm:px-7 py-2.5 sm:py-3 text-base sm:text-lg font-semibold no-underline transition ${colors.action}`}
          to={to}
        >
          View Tasks <FiArrowRight className="h-5 w-5" />
        </Link>
      </div>

      {illustration ? (
        <img
          alt=""
          aria-hidden="true"
          className="absolute bottom-3 right-0 w-28 sm:bottom-3 sm:right-5 sm:w-44 md:right-7 md:w-52 pointer-events-none transition-all duration-200"
          src={illustration}
        />
      ) : (
        <div className={`absolute bottom-5 right-[-0.5rem] flex h-28 w-28 items-center justify-center rounded-full ${colors.visual} sm:bottom-6 sm:right-6 sm:h-44 sm:w-44 md:right-10 md:h-48 md:w-48 pointer-events-none`}>
          <div className="flex h-20 w-16 rotate-[-8deg] items-center justify-center rounded-xl border-2 border-white bg-white shadow-lg sm:h-32 sm:w-24 sm:rounded-2xl sm:border-4 sm:shadow-xl md:h-36 md:w-28">
            <VisualIcon className={`h-11 w-11 ${colors.icon} sm:h-16 sm:w-16 md:h-20 md:w-20`} strokeWidth={1.7} />
          </div>
        </div>
      )}
    </section>
  );
}
